import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-close-dark.svg'


const _hoisted_1 = { class: "scroll-wrapper form-limited" }
const _hoisted_2 = { class: "alert-box" }
const _hoisted_3 = { class: "document-info" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "wrapper-document-name"
}
const _hoisted_6 = { class: "document-name" }
const _hoisted_7 = { class: "controls" }
const _hoisted_8 = {
  key: 0,
  class: "uploading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: $setup.modalClasses
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "modal__title" }, "Secure Document Uploader", -1)),
        _createElementVNode("div", _hoisted_2, [
          ($setup.activeSuccessMessage)
            ? (_openBlock(), _createBlock($setup["AlertComponent"], {
                key: 0,
                message: $setup.activeSuccessMessage,
                type: "success"
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          ($setup.activeWarningMessage)
            ? (_openBlock(), _createBlock($setup["AlertComponent"], {
                key: 1,
                message: $setup.activeWarningMessage,
                type: "danger"
              }, null, 8, ["message"]))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "document-sub-title" }, "Document", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "line" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["DropDown"], {
            class: _normalizeClass(["dropdown-document-type", { 'not-selected-type': $setup.alertMessages.warning[0] === $setup.activeWarningMessage }])
          }, {
            control: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["dropdown-button", [{ 'active-label': $setup.activeDocumentType.value }]])
              }, _toDisplayString($setup.activeDocumentType.label), 3)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentTypes, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    onClick: ($event: any) => ($setup.changeDocumentType(item)),
                    class: _normalizeClass({ 'dropdown__item-active': $setup.activeDocumentType.label === item.label })
                  }, _toDisplayString(item.label), 11, _hoisted_4))
                }), 256))
              ])
            ]),
            _: 1
          }, 8, ["class"]),
          ($setup.activeDocument.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString($setup.activeDocument.name), 1),
                _createElementVNode("img", {
                  class: "document-name-close",
                  src: _imports_0,
                  onClick: $setup.unselectFile
                })
              ]))
            : (_openBlock(), _createBlock($setup["InputFile"], {
                key: 1,
                class: "input-file",
                onChange: $setup.onChangeFile,
                text: "Choose file",
                viewClass: "input-file--text",
                accept: $setup.acceptedTypes
              }, null, 8, ["accept"]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "button button--cancel",
            onClick: $setup.onCancel
          }, "Cancel"),
          ($setup.isUploading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", null, "Uploading...", -1),
                _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          (!$setup.isUploading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button button-primary-with-icon upload",
                onClick: $setup.onUpload
              }, "Upload"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen", "classes"]))
}